"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Table;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Table(props) {
  var _props$size, _props$responsive;
  const size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'sm';
  const responsive = (_props$responsive = props.responsive) !== null && _props$responsive !== void 0 ? _props$responsive : true;
  const classes = ['table'];
  if (props.className) {
    classes.push(props.className);
  }
  if (props.bordered) {
    classes.push('table-bordered');
  }
  if (props.hover) {
    classes.push('table-hover');
  }
  if (props.inverse) {
    classes.push('table-inverse');
  }
  if (props.reflow) {
    classes.push('table-reflow');
  }
  if (size !== 'md') {
    classes.push('table-' + props.size);
  }
  if (props.striped) {
    classes.push('table-striped');
  }
  const formattedTable = /*#__PURE__*/_react.default.createElement("table", {
    className: classes.join(' '),
    style: props.style
  }, props.children);
  if (responsive) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "table-responsive"
    }, formattedTable);
  }
  return formattedTable;
}